<template>
  <div>
    <div class="home-container" v-if="needShowDataList && !showLogin">
      <list v-model="isLoading"
            :finished="dataLoadingFinished"
            loading-text=" "
            finished-text="到底了"
            @load="InitItemFeed"
      >
<!--        <book-shelf-list :data="dataList" :show-remove="showRemove"></book-shelf-list>-->
        <MixItemList :data="dataList"></MixItemList>
      </list>
    </div>
  </div>
</template>

<script>
  import {Toast, List} from "vant"
  import MixItemList from "@/components/ugc_item/MixItemList";
  import BookShelfList from "./BookShelfList";

  export default {
    name: "BookColumnFeed",
    components: {
      BookShelfList, MixItemList, Toast, List,
    },
    props: {
      listType: {},
      showDataList: {}
    },
    data() {
      return {
        currentPage: 0,
        maxCursor: 0,
        totalCount: 0,
        countPerPage: 0,
        offset: 0,
        needShowDataList: true,

        showLogin: false,
        isLoading: false,
        dataLoadingFinished: false,

        dataList: [],
      };
    },
    mounted() {
      this.initParams()
    },
    methods: {
      initParams() {
        let curPage = this.$route.query.page
        if (curPage) {
          this.currentPage = parseInt(curPage)
        } else {
          this.currentPage = 0
        }
        this.offset = 0
        this.dataList = []
        this.dataLoadingFinished = false
        this.showLogin = false
      },

      async InitItemFeed() {
        this.isLoading = true
        let params = {
          page: this.currentPage,
          offset: this.offset,
          list_type: this.listType,
        }
        await this.$store.dispatch("GetFeedItemList", params).then((result) => {
          if (result.code === 0) {
            this.dataList.push(...result.data);
            let extra = result.extra
            this.totalCount = extra.total_count
            this.countPerPage = extra.count_per_page
            this.offset = extra.max_cursor  // 下一次请求的 offset
            this.dataLoadingFinished = !extra.has_more
          } else if (result.code === 20010) {
            this.showLogin = true
            this.dataList = []
            this.totalCount = 0
            this.dataLoadingFinished = true
          } else {
            Toast("请求错误")
            this.dataLoadingFinished = true
          }
        }, () => {
          Toast("网络异常")
          this.dataLoadingFinished = true
        });
        this.isLoading = false
      },

      onChange() {
        let params = {
          page: this.currentPage,
          list_type: this.listType,
        }
        this.$router.push({query: params})
        this.initParams()
        this.InitItemFeed()
      },

      onLoginSuccess() {
        window.location.reload()
      }
    },
    computed: {
      showRemove() {
        if (this.listType === "book_shelf") {
          return true
        } else {
          return false
        }
      }
    },
    watch: {
      listType() {
        this.currentPage = 0
        this.onChange()
      },
      showDataList() {
        this.needShowDataList = this.showDataList
      },

    }
  };
</script>

<style scoped>
  .home-container {
    position: relative;
  }
</style>
